import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class ClientsHome extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            clients:this.props.clients, 
            content:this.props.content, 
            
        }
        

    }
     
    componentDidMount()
    {  
         

                if(this.props.clients && this.state.loading === 1)
                {
                    this.setState({loading:0});     
                }
       
               const script = document.createElement("script");
               script.src   = base_url+"assets/js/loadClients.js";  
               script.async = true;
               document.body.appendChild(script);
       
               script.onload = () => {
               if (window.loadClientsHome && this.props.clients.length > 0) {
               window.loadClientsHome();
               this.setState({loading:0})
               }
               };
         
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (

          <div class="section-full p-t30 p-b30">
                <div class="container">
                 
                    <div class="section-head text-center">
                        <h2 class="text-uppercase">Our Clients</h2>
                        <div class="wt-separator-outer">
                            <div class="wt-separator style-square">
                                <span class="separator-left site-bg-primary"></span>
                                <span class="separator-right site-bg-primary"></span>
                            </div>
                        </div>
                       
                    </div> 
                    <div class="section-content">
                                         
                                        <div class="section-content ">
                                            <div class="owl-carousel client-logo-carousel services-carousel-3-col">
                                      
                                        {this.props.clients.map((item, index) => (
                                             <div class="item">
                                <div class="ow-client-logo">
                                    <div class="client-logo wt-img-effect on-color">
                                        <img src={item.image} alt="" />
                                    </div>
                                </div>
                            </div>  
                                        ))}
                                           
                                        </div>
                                    </div>
                                </div>
                     
                </div>
            
            </div>
   
       
    );
}

}

export default ClientsHome;